import * as am5 from '@amcharts/amcharts5';

am5.addLicense("AM5C367626205")

export default {
    ...am5,
    randomString: function() {
        let length = 10
        const characters = 'abcdefghijklmnopqrstuvwxyz';
        let result = ' ';
        const charactersLength = characters.length;
        for(let i = 0; i < length; i++) {
            result += 
            characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result
    }
}
